import { render, staticRenderFns } from "./TeacherLogin.vue?vue&type=template&id=31ae6fd4&"
import script from "./TeacherLogin.vue?vue&type=script&lang=js&"
export * from "./TeacherLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports